import React, { useState, useEffect } from "react"
import { Snackbar, Alert, Slide } from "@mui/material"

const Toast = ({
    open,
    message,
    severity = "info",
    duration = 5000,
    onClose
}) => {
    const [internalOpen, setInternalOpen] = useState(open)

    useEffect(() => {
        setInternalOpen(open)
    }, [open])

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setInternalOpen(false)
        if (onClose) {
            onClose()
        }
    }

    const TransitionUp = (props) => {
        return <Slide {...props} direction='up' />
    }

    return (
        <Snackbar
            open={internalOpen}
            autoHideDuration={duration}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            TransitionComponent={TransitionUp}>
            <Alert
                onClose={handleClose}
                severity={severity}
                variant='filled'
                sx={{
                    width: "100%",
                    fontSize: "1.2rem",
                    fontWeight: 600
                }}>
                {message}
            </Alert>
        </Snackbar>
    )
}

export default Toast
